<template>
	<div class="voice-item">
		<VoiceIcon
			class="voice-item__icon"
			:src="props.voice.imageUrl"
			:name="props.voice.name"
			:isSelected="props.isSelected"
			:hasProgress="props.isSelected"
			:progress="props.playProgress"
			@click="handleClick"
		/>

		<VoicePrice
			class="voice-item__price"
			:price="props.voice.price"
		/>

		<div class="voice-item__name body-sm">
			{{ props.voice.name }}
		</div>
	</div>
</template>

<script setup lang="ts">
import { Voice } from '../../../types/Voice';

import VoiceIcon from './VoiceButton.vue';
import VoicePrice from './VoicePrice.vue';

const props = withDefaults(
	defineProps<{
		voice: Voice;
		isSelected?: boolean;
		playProgress?: number;
	}>(),
	{
		isSelected: false,
		playProgress: undefined,
	},
);

const emit = defineEmits<{
	onClick: [voice: Voice];
}>();

const handleClick = () => {
	emit('onClick', props.voice);
};
</script>

<style scoped lang="scss">
.voice-item {
	display: flex;
	flex-direction: column;
	place-items: center;
	max-width: 86px;

	&__price {
		transform: translateY(-10px);
	}

	&__name {
		overflow: hidden;

		width: 100%;

		text-align: center;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
}
</style>
